import {IAlgoliaEventData} from '../../IAlgoliaManager';
import EventModel from '../EventModel';

/**
 * Represents AlgoliaProductAddToCartEventModel
 */
export default class AlgoliaProductAddToCartEventModel extends EventModel {
	public data: IAlgoliaEventData;

	/**
	 * @constructor
	 * @param {IAlgoliaEventData} data - data
	 */
	constructor(data: IAlgoliaEventData) {
		super(data);

		const {productID} = data;

		this.data.objectIDs = [productID];
	}
};
